var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.1 109.854 16 16",
    enableBackground: "new 78.1 109.854 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M78.1,109.854v16h16v-16H78.1z M79.1,124.854v-4.042l3.313-2.637l3.001,2.717l-2.487,3.945l0.026,0.017 H79.1z M93.1,124.854h-9l5.59-8.87l3.391,3.391l0.02-0.02V124.854z M93.1,117.98l-3.588-3.589l-3.556,5.642l-3.501-3.168 l-3.354,2.669v-8.68h14V117.98z M86.392,115.271c1.08,0,1.958-0.879,1.958-1.959s-0.878-1.958-1.958-1.958 s-1.958,0.878-1.958,1.958S85.312,115.271,86.392,115.271z M86.392,112.354c0.528,0,0.958,0.43,0.958,0.958 s-0.43,0.959-0.958,0.959s-0.958-0.431-0.958-0.959S85.863,112.354,86.392,112.354z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage01);
export default __webpack_public_path__ + "static/media/icon_image-01.ecba343ed85d62ee0568e08c2b197983.svg";
export { ForwardRef as ReactComponent };